/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSelectFieldSchema } from "cms/fields/dynamic-field";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

const useDateTimeOptions = () => {
    const { t } = useTranslation();
    const {
        type,
        name,
        index,
        disabled = false
    } = useContext(ListItemContext);
    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { styleOptions, formatOptions, placeholder } = schemaSettings || {};

    const ph = placeholder || t("commons.placeholderText");

    return {
        type,
        index,
        disabled,
        placeholder: ph, 
        styleOptions,
        formatOptions
    };
};

export { useDateTimeOptions };
